// Señal global de "hay una acción en curso": Sina muestra el camión mientras el contador sea > 0.
const listeners = new Set();
let count = 0;

function emit() {
  listeners.forEach((listener) => listener());
}

export function getSinaBusyCount() {
  return count;
}

export function subscribeToSinaBusy(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Marca el inicio de una acción; devuelve la función que la libera (idempotente). */
export function startSinaBusy() {
  let released = false;
  count += 1;
  emit();
  return () => {
    if (released) return;
    released = true;
    count -= 1;
    emit();
  };
}

/** Mantiene a Sina ocupada mientras la promesa esté pendiente y devuelve su resultado. */
export function trackSinaBusy(promise) {
  const release = startSinaBusy();
  return Promise.resolve(promise).finally(release);
}
